import { Container, Link, Text } from '@melio/penny';

import { TERMS_OF_SERVICE_URL, PRIVACY_POLICY_URL } from '../../constants/urls';

export const TermsFooter = () => {
  return (
    <Container textAlign="center">
      <Text textStyle="body4" color="semantic.text.secondary">
        By continuing, you are agreeing to Melio&apos;s{' '}
        <Link href={TERMS_OF_SERVICE_URL} color="inherit" label="Terms of Service" variant="inline" newTab data-testid="terms-link" /> and{' '}
        <Link href={PRIVACY_POLICY_URL} color="inherit" label="Privacy Policy" variant="inline" newTab data-testid="privacy-link" />.
      </Text>
    </Container>
  );
};
